import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, KeepAlive as _KeepAlive, Teleport as _Teleport, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

import { BOTTOM, LEFT, RIGHT } from '@shell/utils/position';
import HorizontalPanel from './panels/HorizontalPanel.vue';
import VerticalPanel from './panels/VerticalPanel.vue';
import PinArea from './PinArea.vue';
import useComponentsMount from './composables/useComponentsMount';
import useTabsHandler from './composables/useTabsHandler';
import usePanelsHandler from '@shell/components/nav/WindowManager/composables/usePanelsHandler';
import { Layout, Position } from '@shell/types/window-manager';

/**
 * This component is responsible for rendering the window manager panels and tabs.
 * It uses composables to manage the state and behavior of the panels and tabs.
 *
 * Props:
 * - Layouts define which panels are enabled depending on the UI area configuration.
 * - Positions define where the panels are located (bottom, left, right).
 *
 * Behavior:
 * - Panels are conditionally rendered based on the current layout and enabled positions.
 * - Tabs bodies are teleported to their respective containers based on their configuration.
 *   - The component for each tab is dynamically loaded and rendered within a keep-alive block.
 * - The PinArea component is included to manage the dragging of tabs.
 */


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  layout: {
    type:    String as () => Layout,
    default: Layout.default,
  },
  positions: {
    type:    Array as () => Position[],
    default: () => [BOTTOM, LEFT, RIGHT]
  },
},
  setup(__props) {

const props = __props;

const { loadComponent } = useComponentsMount();

const { isPanelEnabled } = usePanelsHandler(props);
const { tabs } = useTabsHandler();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isPanelEnabled)[_unref(BOTTOM)])
      ? (_openBlock(), _createBlock(HorizontalPanel, {
          key: 0,
          position: _unref(BOTTOM)
        }, null, 8, ["position"]))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createTextVNode()),
    (_unref(isPanelEnabled)[_unref(LEFT)])
      ? (_openBlock(), _createBlock(VerticalPanel, {
          key: 1,
          position: _unref(LEFT)
        }, null, 8, ["position"]))
      : _createCommentVNode("", true),
    _cache[1] || (_cache[1] = _createTextVNode()),
    (_unref(isPanelEnabled)[_unref(RIGHT)])
      ? (_openBlock(), _createBlock(VerticalPanel, {
          key: 2,
          position: _unref(RIGHT)
        }, null, 8, ["position"]))
      : _createCommentVNode("", true),
    _cache[2] || (_cache[2] = _createTextVNode()),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), ({ tab, containerId }) => {
      return (_openBlock(), _createBlock(_Teleport, {
        key: tab.id,
        to: `#${ containerId }`
      }, [
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(loadComponent)(tab)), _mergeProps({
            key: tab.id,
            tab: tab,
            active: true,
            height: tab.containerHeight,
            width: tab.containerWidth,
            layout: __props.layout
          }, { ref_for: true }, tab.attrs), null, 16, ["tab", "height", "width", "layout"]))
        ], 1024))
      ], 8, ["to"]))
    }), 128)),
    _cache[3] || (_cache[3] = _createTextVNode()),
    _createVNode(PinArea)
  ], 64))
}
}

})